export default __webpack_public_path__ + "static/media/023-astronaut.4fe13fa8.svg";